import React, { useCallback, useMemo } from 'react';
import { Flex, RemoteImage } from '@banhala/ui-kit';
import { isNil, isNotNil } from 'shared/src/utils';
import { useConfigs } from 'shared/src/queries';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useDeliveryTypeTodayInfoBottomSheet } from './DeliveryTypeTodayInfoBottomSheet';
import { useLogClickTooltip } from '../hooks/useLogClickTooltip';
import { IconTooltip } from './IconTooltip';
import { isSalesMethodIsPreOrder } from '../../../utils/isSalesMethodIsPreOrder';
import { isDeliveryTypeIsThirdPL } from '../../../utils/isDeliveryTypeIsThirdPL';

export const DeliveryBadgeRow = ({ testID }: { testID?: string }) => {
  const { data: goodsBasic } = useGoodsBasic();
  const { data: configs } = useConfigs();
  const { show: showDeliveryTypeTodayInfo } =
    useDeliveryTypeTodayInfoBottomSheet();
  const logClickTooltip = useLogClickTooltip();

  const iconUrl = useMemo(() => {
    if (isSalesMethodIsPreOrder(goodsBasic)) {
      return goodsBasic?.sales_method_info?.icon_url ?? null;
    }
    return goodsBasic?.delivery_type_info?.icon_url ?? null;
  }, [goodsBasic]);

  const goodsBasicIconUrl = useMemo(() => {
    if (isSalesMethodIsPreOrder(goodsBasic)) {
      return configs?.pre_order_sales_method?.guide_image ?? null;
    }

    if (isDeliveryTypeIsThirdPL(goodsBasic)) {
      return configs?.third_pl_delivery?.guide_image ?? null;
    }

    return configs?.today_delivery?.integrate_guide_image ?? null;
  }, [goodsBasic, configs]);

  const onPress = useCallback(() => {
    if (isNil(iconUrl) || isNil(goodsBasicIconUrl)) return;

    logClickTooltip();
    showDeliveryTypeTodayInfo({
      iconUrl: iconUrl,
      guideImageUrl: goodsBasicIconUrl,
    });
  }, [showDeliveryTypeTodayInfo, logClickTooltip, iconUrl, goodsBasicIconUrl]);

  return (
    <Flex.Row gap={2} alignItems={'center'} onPress={onPress} testID={testID}>
      {isNotNil(iconUrl) && (
        <RemoteImage uri={iconUrl} width={49} height={13} />
      )}
      <IconTooltip />
    </Flex.Row>
  );
};
